import { render, staticRenderFns } from "./ValidateCustomer.vue?vue&type=template&id=41ff0c70&scoped=true"
import script from "./ValidateCustomer.vue?vue&type=script&lang=js"
export * from "./ValidateCustomer.vue?vue&type=script&lang=js"
import style0 from "./ValidateCustomer.vue?vue&type=style&index=0&id=41ff0c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ff0c70",
  null
  
)

export default component.exports